<div class="forecast-table-grid-select-container">
  <ng-select
    class="forecast-table-grid-select"
    [disabled]="true"
    [auxTooltip]="tooltip"
    [ngModel]="selectedPeriodPatientOption"
    [items]="periodPatientOptions">
  </ng-select>
</div>
